'use strict';

angular.module('app').directive('searchInput', function ($window) {

    var link = function (scope, element, attr) {
        var sortRow = $('.sort-row.small'),
            results = $('.results'),
            filters = $('#js-filters-wrap'),
            map = $('#search-map'),
            content = $('#content');
            
        element.bind('focus',function () {
            if($window.innerWidth < 1024) {
                var isToggled = scope.callback();
                sortRow.hide(400);
                filters.show(400);
                results.hide(400);

                content.css({width:'100%','border-right-width':'',display: 'block'});
                map.animate({width:''});
            }
        });
    };

    return {
        restrict: 'A',
        replace: false,
        scope: {
            currentView: '=',
            callback: '&'
        },
        link: link
    };
})